// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../core/material.module';
import { TextMaskModule } from 'angular2-text-mask';

// Services
import { TeamService } from './Services/team.service';

// Components
import { TeamMemberListComponent } from './Components/team-member-list/team-member-list.component';
import { TeamMemberDetailComponent } from './Components/team-member-detail/team-member-detail.component';
import { TeamMemberAddComponent } from './Components/team-member-add/team-member-add.component';
import { TeamMemberEditComponent } from './Components/team-member-edit/team-member-edit.component';
import { TeamGSLComponent, TeamGslManageComponent } from './Components/team-manage/team-gsl/team-gsl.component';

@NgModule({
    declarations: [
        TeamMemberListComponent, TeamMemberDetailComponent,
        TeamMemberAddComponent, TeamMemberEditComponent,
        TeamGSLComponent, TeamGslManageComponent
    ],
    imports: [
        CommonModule, RouterModule, FormsModule, MaterialModule,
        TextMaskModule
    ],
    entryComponents: [TeamGslManageComponent],
    providers: [TeamService]
})

export class TeamModule {}